var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer footerContainer"},[(_vm.userPermissions.indexOf('full:credits') > -1)?[_c('p',[_vm._v("© Brandon Yee")])]:_vm._e(),(_vm.userPermissions.indexOf('dev:credits') > -1)?[_c('p',[_vm._v("[[ ADMIN ]]")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }